import { getUUID } from "@hex-insights/core";
import { applicationDetails } from "@hex-insights/verita-romania.shared";

export { projectName, mainServerAppName, jwtIssuer } from "@hex-insights/verita-romania.shared";

applicationDetails.portal = "parent-portal";

export const appName = "Parent Portal";
export const appVersion = process.env.REACT_APP_VERSION ?? "";
export const instanceID = getUUID();
